var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.639942 9.11972H10.2399C10.5919 9.11972 10.8799 8.57986 10.8799 7.91993C10.8799 7.26 10.5919 6.72015 10.2399 6.72015L0.639942 6.71973C0.287931 6.71973 0 7.25958 0 7.91951C0 8.57948 0.287948 9.11973 0.639942 9.11973V9.11972Z",
    fill: "url(#paint0_linear_3496_57421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6399 0H0.639942C0.287931 0 0 0.539951 0 1.2C0 1.86008 0.287949 2.4 0.639942 2.4H16.6399C16.9919 2.4 17.2799 1.86005 17.2799 1.2C17.2799 0.539919 16.9919 0 16.6399 0Z",
    fill: "url(#paint1_linear_3496_57421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67989 14.3201C7.67989 13.66 7.39194 13.1201 7.03994 13.1201H0.639943C0.287932 13.1201 0 13.6601 0 14.3201C0 14.9802 0.287949 15.5201 0.639943 15.5201H7.03994C7.39195 15.5205 7.67989 14.9802 7.67989 14.3201Z",
    fill: "url(#paint2_linear_3496_57421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3496_57421",
    x1: 0,
    y1: 7.91973,
    x2: 10.8799,
    y2: 7.91973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3496_57421",
    x1: 0,
    y1: 1.2,
    x2: 17.2799,
    y2: 1.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3496_57421",
    x1: 0,
    y1: 14.3201,
    x2: 7.67989,
    y2: 14.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedHamburger);
export default __webpack_public_path__ + "static/media/AnimatedHamburger.a51d60f24a43c52f368472fa7258c707.svg";
export { ForwardRef as ReactComponent };